import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

const MODES = ["light", "dark", "high-contrast"];

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("sc_theme") || "light");
  const [voiceAssist, setVoiceAssist] = useState(
    () => localStorage.getItem("sc_voice_assist") === "1"
  );
  const [largeText, setLargeText] = useState(
    () => localStorage.getItem("sc_large_text") === "1"
  );

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "hc");
    if (mode === "dark") root.classList.add("dark");
    if (mode === "high-contrast") root.classList.add("hc");
    root.dataset.theme = mode;
    localStorage.setItem("sc_theme", mode);
  }, [mode]);

  useEffect(() => {
    document.documentElement.classList.toggle("large-text", largeText);
    localStorage.setItem("sc_large_text", largeText ? "1" : "0");
  }, [largeText]);

  useEffect(() => {
    localStorage.setItem("sc_voice_assist", voiceAssist ? "1" : "0");
  }, [voiceAssist]);

  const cycle = useCallback(() => {
    setMode((m) => MODES[(MODES.indexOf(m) + 1) % MODES.length]);
  }, []);

  const speak = useCallback(
    (text) => {
      if (!voiceAssist || !text || typeof window === "undefined" || !window.speechSynthesis) return;
      window.speechSynthesis.cancel();
      const utt = new SpeechSynthesisUtterance(text);
      utt.lang = "es-ES";
      utt.rate = 0.95;
      window.speechSynthesis.speak(utt);
    },
    [voiceAssist]
  );

  return (
    <ThemeContext.Provider
      value={{ mode, setMode, cycle, voiceAssist, setVoiceAssist, largeText, setLargeText, speak }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
